import { ArrowUturnLeftIcon } from '@heroicons/react/24/outline';
import { FC } from 'react';
import { ThreadActionButton } from '..';

interface ReplyButtonProps {
  onClick: () => void;
}

export const ReplyButton: FC<ReplyButtonProps> = (props) => {
  return (
    <ThreadActionButton
      icon={ArrowUturnLeftIcon}
      text="Reply"
      aria-label="reply to this comment"
      {...props}
    />
  );
};
